function initOotdCarousels() {
  var rows = document.querySelectorAll('[data-ootd-row]');

  rows.forEach(function (row) {
    var track = row.querySelector('[data-ootd-track]');
    if (!track || track.dataset.ootdInit === 'true') return;
    track.dataset.ootdInit = 'true';

    var prevBtn = row.querySelector('[data-ootd-prev]');
    var nextBtn = row.querySelector('[data-ootd-next]');

    var items = Array.prototype.slice.call(track.children);
    var realCount = parseInt(row.dataset.ootdCount || '0', 10);

    var scrollItemToCenter = function (item, instant) {
      if (!item) return;
      var target = item.offsetLeft - track.offsetLeft - (track.clientWidth / 2) + (item.offsetWidth / 2);
      if (instant) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        track.style.scrollBehavior = '';
      } else {
        track.scrollLeft = target;
      }
    };

    // start on the first real item (index 1, since index 0 is the cloned last item)
    if (realCount > 1 && items.length > 1) {
      scrollItemToCenter(items[1], true);
    }

    var scrollTimer = null;
    var isInteracting = false;

    var itemScrollAmount = function () {
      var item = track.querySelector('.ootd-row__item');
      var gap = parseInt(getComputedStyle(track).columnGap, 10);
      if (isNaN(gap)) gap = 0;
      return item ? item.getBoundingClientRect().width + gap : 240;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -itemScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: itemScrollAmount(), behavior: 'smooth' });
      });
    }

    var getCenteredItem = function () {
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closest = null;
      var closestDistance = Infinity;

      items.forEach(function (item) {
        var itemRect = item.getBoundingClientRect();
        var itemCenter = itemRect.left + itemRect.width / 2;
        var distance = Math.abs(itemCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = item;
        }
      });

      return closest;
    };

    var handleScrollEnd = function () {
      // never rewrite scrollLeft while the user is still touching/dragging —
      // doing so mid-gesture can break the browser's scroll tracking entirely
      if (isInteracting) return;
      if (realCount <= 1) return;

      var centered = getCenteredItem();
      if (!centered) return;

      var index = items.indexOf(centered);

      // if we've landed on the cloned-last (index 0), jump to the real last item
      if (index === 0) {
        scrollItemToCenter(items[realCount], true);
      }

      // if we've landed on the cloned-first (final index), jump to the real first item
      if (index === items.length - 1) {
        scrollItemToCenter(items[1], true);
      }
    };

    track.addEventListener('touchstart', function () {
      isInteracting = true;
      if (scrollTimer) clearTimeout(scrollTimer);
    }, { passive: true });

    track.addEventListener('mousedown', function () {
      isInteracting = true;
      if (scrollTimer) clearTimeout(scrollTimer);
    });

    var onInteractionEnd = function () {
      isInteracting = false;
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(handleScrollEnd, 120);
    };

    track.addEventListener('touchend', onInteractionEnd, { passive: true });
    track.addEventListener('touchcancel', onInteractionEnd, { passive: true });
    document.addEventListener('mouseup', function () {
      if (isInteracting) onInteractionEnd();
    });

    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(handleScrollEnd, 120);
    }, { passive: true });
  });

  // swap ghost for real image once loaded (safe to re-run, checks are idempotent)
  document.querySelectorAll('[data-ootd-image]').forEach(function (img) {
    if (img.dataset.ootdChecked === 'true') return;

    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
      img.dataset.ootdChecked = 'true';
      return;
    }

    img.dataset.ootdChecked = 'true';
    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
    });
    img.addEventListener('error', function () {
      // leave ghost visible if the image fails to load
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOotdCarousels);
} else {
  initOotdCarousels();
}

// re-run when the theme editor adds/reorders blocks or re-renders this section
document.addEventListener('shopify:section:load', initOotdCarousels);
document.addEventListener('shopify:block:select', initOotdCarousels);
document.addEventListener('shopify:section:reorder', initOotdCarousels);